import * as url from "../../helpers/url_helper";
import { apiCall } from "./apiService";

/**
 * Updates placement value for a store
 * @param {string} shop - Shop domain
 * @param {number} placement - Placement value
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Response data or null if error
 */
export const updatePlacement = async (shop, placement, notifyError) => {
    return await apiCall(
        url.PUT_UPDATE_MERCHANTS,
        'PUT',
        {
            shop,
            placement: parseInt(placement),
        },
        notifyError,
        "Failed to update placement"
    );
};

/**
 * Updates total fees for a store
 * @param {string} shop - Shop domain
 * @param {number} totalFees - Total fees value
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Response data or null if error
 */
export const updateTotalFees = async (shop, totalFees, notifyError) => {
    return await apiCall(
        url.PUT_UPDATE_MERCHANTS,
        'PUT',
        {
            shop,
            total_fees: parseInt(totalFees),
        },
        notifyError,
        "Failed to update total fees"
    );
};

/**
 * Updates store settings property
 * @param {string} shop - Shop domain
 * @param {number} storeId - Store ID
 * @param {string} field - Field name to update
 * @param {any} value - Value to set
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Response data or null if error
 */
export const updateStoreSettings = async (shop, storeId, field, value, notifyError) => {
    const result = await apiCall(
        url.PUT_UPDATE_STORE_SETTINGS,
        'PUT',
        {
            shop,
            properties: {
                store_id: storeId,
                [field]: value,
            },
        },
        notifyError,
        `Failed to update ${field}`
    );
    if (result?.status) {
        return true
    } else {
        return false
    }
};

